import React from 'react';
import { cn } from '../../lib/utils';

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <div
      className={cn(
        'rounded-md bg-gradient-to-r from-muted/70 via-muted/40 to-muted/70 bg-[length:200%_100%] motion-safe:animate-shimmer',
        className,
      )}
      aria-hidden="true"
      {...props}
    />
  );
};

export { Skeleton };
